import { render, staticRenderFns } from "./SkipToMain.vue?vue&type=template&id=4aa18059&scoped=true"
import script from "./SkipToMain.vue?vue&type=script&lang=js"
export * from "./SkipToMain.vue?vue&type=script&lang=js"
import style0 from "./SkipToMain.vue?vue&type=style&index=0&id=4aa18059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa18059",
  null
  
)

export default component.exports